import {
  PASSWORD_RESET_EMAIL_PLACEHOLDER,
  PASSWORD_RESET_EMAIL_QUERY_PARAM,
  PASSWORD_RESET_TOKEN_PLACEHOLDER,
  PASSWORD_RESET_TOKEN_QUERY_PARAM,
} from '@features/auth/constants/passwordReset';

import { ROUTE_PATHS } from '@router/paths';
import { RouteName } from '@router/routeNames';

/** Builds the link the backend emails for a password reset, with the placeholders it fills in. */
export const buildPasswordResetUrl = (origin: string): string => {
  const query = [
    `${PASSWORD_RESET_EMAIL_QUERY_PARAM}=${PASSWORD_RESET_EMAIL_PLACEHOLDER}`,
    `${PASSWORD_RESET_TOKEN_QUERY_PARAM}=${PASSWORD_RESET_TOKEN_PLACEHOLDER}`,
  ].join('&');

  return `${origin}${ROUTE_PATHS[RouteName.AUTH_PASSWORD_RESET]}?${query}`;
};
